module.exports = __webpack_public_path__ + "static/media/Icon simple-email.1bdec8af.svg";